<template>
  <div class="custom-filter">
    <div class="input-wrap">
      <el-autocomplete 
        v-model="keyword" 
        clearable
        ref="customFilterInput"
        :placeholder="placeholder" 
        @keyup.enter.native="searchHandler()" 
        @clear="clearInput()"
        :fetch-suggestions="(keyword, cb) => cb(keyword ? searchHistory.filter(item => item.indexOf(keyword) != -1) : searchHistory)"
        @select="keyword => keyword && searchHandler(keyword)"
        popper-class="custom-filter-popper"
        :maxlength="100">
        <template slot-scope="{item}">
          <span>{{item.length > 60 ? `${item.substr(0, 60)}...` : item}}<i class="el-icon-close" @click.stop="delHistory(item)" /></span>
        </template>
      </el-autocomplete>
      <div class="search-button" @click="searchHandler()">
        <slot name="search-button">
          <svg-icon icon-class="u2752" />
        </slot>
      </div>
    </div>
    <div class="dropdown-wrap" v-if="dropdown && dropdown.length">
      <span class="tip">筛选：</span>
      <div class="items-wrap">
        <div 
          v-for="(item, index) in dropdown"
          :key="index" 
          class="dropdown-item">
          <!-- 选择日期 -->
          <div 
            class="date-picker" 
            v-if="item.type && item.type === 'datePicker'">
            <a 
              role="button" 
              class="trigger" 
              @click.stop="showDatePicker(index)">
              {{item.checked_label || item.name }}
            </a>
            <el-date-picker
              v-model="item.time"
              @input="value => filterHandler({ label: value, value }, item)"
              :type="item.dateType"
              :value-format="item.format || 'yyyy-MM-dd'"
              ref="dropdown">
            </el-date-picker>
          </div>

          <!-- 普通下拉项 -->
          <el-dropdown 
            v-else 
            trigger="click" 
            @command="data => filterHandler(data, item)">
            <a role="button" class="trigger">{{ item.checked_label || item.name }}</a>
            <el-dropdown-menu slot="dropdown" class="custom-filter-dropdown" ref="dropdown">
              <el-scrollbar :native="false">
                <el-dropdown-item
                  v-for="(citem, cindex) in item.options"
                  :key="cindex"
                  :command="{
                    label: citem[item.label] || citem.label, 
                    value: citem[item.value] || citem.value
                  }"
                  >
                  {{citem[item.label] || citem.label}}
                </el-dropdown-item>
              </el-scrollbar>
            </el-dropdown-menu>
          </el-dropdown>

          <a 
            role="button" 
            @click="clearFilterItem(item, index)" 
            :class="['clear-btn', {
              'clear-btn-checked': item.checked_label
            }]">
              <i class="el-icon-arrow-down" />
              <i class="el-icon-close" />
          </a>
        </div>
      </div>
      <a role="button" class="reset-btn" @click="reset()">重置</a>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
const SearchHistoryKey = 'SEARCH_HISTORY_KEY';
export default {
  name: 'default',
  data () {
    return {
      searchHistory: [],
      maxHistory: 20,
      lastSearch: null,
      dropdown: []
      /*dropdown: [{
        name: '日期',
        attr: 'date',
        dateType: 'date'
      },
      {
        name: '状态',
        attr: 'status',
        label: 'label',   //数据的label参数名
        value: 'value',   //数据的value参数名,
        options: [{       //下拉选项
          label: '是',
          value: 1
        },
        {       //下拉选项
          label: '否',
          value: 0
        }]
      }]*/
    }
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({})
    },
    dropData: {
      type: Array,
      required: false,
      default: () => []
    },
    placeholder: {
      type: String,
      required: false,
      default: '请输入搜索内容'
    }
  },
  computed: {
    keyword: {
      get(){
        return this.value.keyword || '';
      },
      set(val){
        this.$emit('input', { ...this.value, keyword: val })
      }
    }
  },
  watch: {
    dropData: {
      handler(val){
        let copy = JSON.parse(JSON.stringify(val));
        this.dropdown = copy.map((item, index) => !item.disabled
          ? ({
              ...item,
              checked_label: this.value[item.attr]
              ? this.dropdown[index].checked_label
              : null
            })
          : null
        ).filter(item => item != null)
      },
      immediate: true
    }
  },
  methods: {
    searchHandler(keyword){
      //选中的建议项值
      if(keyword) 
        this.keyword = keyword;
      //将搜索历史记录存储至本地
      let kw = this.keyword || keyword;
      if(kw){
        this.searchHistory = [kw, ...this.searchHistory.filter(item => item != kw).slice(0, (this.maxHistory - 1))];
        localStorage.setItem(SearchHistoryKey, JSON.stringify(this.searchHistory));
      }
      this.$refs.customFilterInput.activated = false;
      this.lastSearch = kw;
      this.$nextTick(
        () => this.$emit('search')
      )
    },
    fetchSearchHistory(){
      try{
        let history = JSON.parse(localStorage.getItem(SearchHistoryKey));
        this.searchHistory = (Array.isArray(history)) ? history : [];
      }catch(e){}
    },
    delHistory(keyword){
      this.searchHistory = this.searchHistory.filter(item => item != keyword);
      localStorage.setItem(SearchHistoryKey, JSON.stringify(this.searchHistory));
      this.$nextTick(() => {
        this.$refs.customFilterInput.getData();
      })
    },
    filterHandler({label, value}, item){
      let filterObj = {};
      let { attr } = item;
      if(attr) filterObj[attr] = value;
      label && this.$set(item, 'checked_label', Array.isArray(label)? label.join(' ~ ') : label);
      this.$emit('input', {...this.value, ...filterObj});
      this.$emit('search');
    },
    clearFilterItem(item, index){
      if(item.checked_label){
        this.$set(item, 'checked_label', null);
        this.$set(item, 'time', null);
        let filterObj = {};
        let { attr } = item;
        if(attr) filterObj[attr] = null;
        this.$emit('input', {...this.value, ...filterObj});
        this.$emit('search');
      }else{
        if(this.$refs.dropdown &&
        this.$refs.dropdown[index]){
          this.$refs.dropdown[index].dropdown &&
          this.$refs.dropdown[index].dropdown.show();

          this.showDatePicker(index);
        }
      }
    },
    reset(){
      this.dropdown.map(item => {
        delete item.checked_label
        delete item.time
        return item;
      })
      this.$emit('input', {});
      this.$emit('search');
    },
    clearInput(){
      this.lastSearch && this.searchHandler();
      this.lastSearch = null;

      let input = this.$refs.customFilterInput.$refs.input;
      input.blur();
    },
    showDatePicker(index){
      this.$refs.dropdown[index].showPicker &&
      this.$refs.dropdown[index].showPicker();
    }
  },
  components: { 
    SvgIcon 
  },
  mounted(){
    this.fetchSearchHistory();
  }
}
</script>

<style lang="scss" scoped>
.custom-filter{
  margin: 1.05rem;
  padding: 0.525rem;
  background-color: #FFF;

  .input-wrap{
    width: 100%;
    position: relative;

    .el-autocomplete{
      width: 100%;
      >>> input{
        padding-right: 2.625rem;
        height: 3.017rem;
        font-size: 1.1rem;
      }
      >>> .el-input__suffix{
        right: 2.625rem;
        i{
          font-size: 1.2rem;
        }
      }
    }

    .search-button{
      font-size: 1.4rem;
      color: #169bd5;
      transition: color .3s;
      cursor: pointer;

      @extend .abs-midY;
      right: 0.875rem;

      &:hover{
        color: darken(#169bd5, 5%);
      }
    }
  }

  .dropdown-wrap{
    display: flex;
    font-size: 0.2275rem;
    height: 0.35rem;
    padding: 1.225rem 0;

    .tip{
      color: #606266;
      font-size: 1.1375rem;
      white-space: nowrap;
    }

    .items-wrap{
      display: flex;
      max-width: calc(100% - 5.25rem);
      flex-direction: row;
      align-items: center;
      min-height: 1.1375rem;
      overflow-x: scroll;
      overflow-y: hidden;
      margin-right: 0.525rem;
      @extend .hide-scrollbar;

      .dropdown-item{
        position: relative;
        margin-right: .7rem;
        padding-right: 1.4rem;

        .trigger{
          color: #606266;
          font-weight: normal;
          font-size: 1.1375rem;
          white-space: nowrap;
        }

        .date-picker{
          font-weight: normal;

          .el-date-editor{
            position: absolute;
            left: 0;
            top: 0.875rem;
            width: 0px;
            height: 0px;
            padding: 0;
            border: 0;
            overflow: hidden;
          }
        }

        .clear-btn{
          color: #606266;
          @extend .abs-midY;
          right: 0;

          .el-icon-close{
            display: none;
          }

          &.clear-btn-checked{
            color: $theme-color;

            .el-icon-close{
              display: inline-block;
            }

            .el-icon-arrow-down{
              display: none;
            }
          }
        }

        .el-icon-arrow-down,
        .el-icon-close{
          font-size: 1.1375rem;
        }
      }
    }
    .reset-btn{
      font-size: 1.1375rem;
      color: #169bd5;
      white-space: nowrap;

      &:hover{
        text-decoration: underline;
      }
    }
  }
}
</style>
<style lang="scss">
.custom-filter-dropdown{
  .el-scrollbar__wrap{
    max-height: 80vh;
  }
}

.custom-filter-popper{
  .el-autocomplete-suggestion__list{
    span{
      display: inline-block;
      width: 88vw;
      position: relative;
      white-space: pre-line;
      word-break: break-word;
      line-height: 1.5;
      font-size: 1.1rem;
  
      .el-icon-close{
        position: absolute;
        top: 0.0875rem;
        right: -0.2625rem;
        transition: color .3s;
        font-size: 1.1rem;
        &:hover{
          color: #169bd5;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomFilter.vue